const dom = {
  submenuBtn: '[data-menu]',
  backBtn: '[data-menu-close]',
  menuContent: '[data-menu-content]',
};

const showSubmenu = (e) => {
  const menu = e.currentTarget;
  const currentMenu = menu.getAttribute('data-menu');
  const submenu = document.getElementById(currentMenu);
  submenu.classList.add('mobile-nav__submenu--is-open');
};

const hideSubmenu = (e) => {
  const menu = e.currentTarget.closest(dom.menuContent);
  menu.classList.remove('mobile-nav__submenu--is-open');
};
const bindUIActions = () => {
  // SubmenuOpen
  const openBtns = document.querySelectorAll(dom.submenuBtn);
  if (!openBtns) return;
  openBtns.forEach((trigger) => {
    trigger.addEventListener('click', (e) => showSubmenu(e));
  });
  // Hide Submenu
  const closeBtns = document.querySelectorAll(dom.backBtn);
  if (!closeBtns) return;
  closeBtns.forEach((trigger) => {
    trigger.addEventListener('click', (e) => hideSubmenu(e));
  });
};

export const init = () => {
  bindUIActions();
};
